import Item from 'common/ITEMS/Item';

const items = {
  //region Affliction
  //endregion
  //region Demonology
  //endregion
  //region Destruction
  //endregion
  //region Shared
  //endregion
} satisfies Record<string, Item>;
export default items;
